import React, { useEffect, useState } from "react";
import {
    Slider,
} from "@mui/material";
export default function IllusionCutSlider(props) {
    const { disabled, framesToTimeCode, handleEditCellChange, params, plateSummary } = props;


    const [cutStart, setCutStart] = useState(plateSummary?.cut?.at(0) ?? 0);
    const [cutEnd, setCutEnd] = useState(plateSummary?.cut?.at(1) ?? 86400);
    const [sourceStart, setSourceStart] = useState(plateSummary?.source?.at(0) ?? 0);
    const [sourceEnd, setSourceEnd] = useState(plateSummary?.source?.at(1) ?? 0);

    const marks = [
        {
            value: sourceStart,
            label: framesToTimeCode(sourceStart),
        },
        {
            value: sourceEnd,
            label: framesToTimeCode(sourceEnd),
        },
    ];

    const handleChange = (_, value) => {
        setCutStart(value?.at(0) ?? 0);
        setCutEnd(value?.at(1) ?? 0);
        handleEditCellChange({ id: params.id, field: params.field, value: value })
    }

    useEffect(() => {
        setCutStart(plateSummary?.cut?.at(0) ?? 0);
        setCutEnd(plateSummary?.cut?.at(1) ?? 86400);
        setSourceStart(plateSummary?.source?.at(0) ?? 0);
        setSourceEnd(plateSummary?.source?.at(1) ?? 0);
    }, [plateSummary]);

    return (
        <Slider
            disabled={disabled}
            size='small'
            value={[cutStart, cutEnd]}
            onChange={handleChange}
            valueLabelDisplay="auto"
            valueLabelFormat={(value, index) => framesToTimeCode(value, plateSummary?.framerate ?? 24)}
            min={sourceStart}
            max={sourceEnd}
            marks={marks}
            sx={{ 
                margin: '0 30px', // Add margin to the slider
                '& .MuiSlider-thumb': {
                    color: disabled ? 'grey' : '#54a277',
                },
                '& .MuiSlider-track': {
                    color: disabled ? 'grey' : '#54a277',
                },
                '& .MuiSlider-rail': {
                    color: disabled ? 'grey' : '#54a277',
                },
                '& .MuiSlider-mark': {
                    color: 'grey',
                },
                '& .MuiSlider-markLabel': {
                    color: disabled ? 'rgba(0,0,0,0)' : 'grey',
                    fontSize: '12px', // Change mark font size
                },
            }}
        />
    );
}